/**
 * @generated SignedSource<<e2491ab785549b96ca0fd43b6cd2bec4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PatronCheckoutLoyaltyRewardsEnrollmentOffer_order$data = {
  readonly loyaltyEnrollmentOffer: {
    readonly points: number;
    readonly terminologyOne: string;
    readonly terminologyOther: string;
  } | null | undefined;
  readonly " $fragmentType": "PatronCheckoutLoyaltyRewardsEnrollmentOffer_order";
};
export type PatronCheckoutLoyaltyRewardsEnrollmentOffer_order$key = {
  readonly " $data"?: PatronCheckoutLoyaltyRewardsEnrollmentOffer_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatronCheckoutLoyaltyRewardsEnrollmentOffer_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatronCheckoutLoyaltyRewardsEnrollmentOffer_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderLoyaltyEnrollmentOffer",
      "kind": "LinkedField",
      "name": "loyaltyEnrollmentOffer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "points",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "terminologyOne",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "terminologyOther",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "a653db12a331d72ff24aba12fec46d9c";

export default node;
